import { qtsp } from '@shared/tracking-qtsbinds';
import { gaTrackEvent } from './all-ga-events';

function processEvent(event) {
  const eventName = event.event;
  if (eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
  if (eventName == 'NonHireMe Posted') {
    gaTrackEvent('GoalNonHireMePosted');
    _ttref.push(['_trackEvent', 'PostProject', 'Posted']);
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_PostProjectForm']);
  } else if (eventName == 'Project Reposted') {
    if (event.isHireMe) {
      gaTrackEvent('GoalHireMeReposted');
    } else {
      gaTrackEvent('GoalNonHireMeReposted');
    }
  } else if (eventName == 'Project Upgraded') {
    gaTrackEvent('GoalProjectUpgraded');
  } else if (eventName == 'HireMe Posted') {
    gaTrackEvent('GoalHireMePosted');
  } else if (eventName == 'Buy Exam') {
    if (event.isFree) {
      gaTrackEvent('GoalBuyFreeExam');
    } else {
      gaTrackEvent('GoalBuyPaidExam');
    }
    _ttref.push(['_trackEvent', 'Exams', 'ConfirmBuy', event.examName]);
  } else if (eventName == 'Bid on Project') {
    _ttref.push(['_trackEvent', 'Project', 'Bid', '', 0, true, true]);
    qtsp.push({
      label: 'PlaceBid',
      amount: event.amount,
      currency: event.currency,
    });
    gaTrackEvent('GoalBidProject');
  } else if (eventName == 'User Registration') {
    if (event.user_type == 'Employer') {
      gaTrackEvent('GoalUserRegistrationEmployer');
    } else {
      gaTrackEvent('GoalUserRegistrationFreelancerBoth');
    }
  } else if (eventName == 'Facebook Signup') {
    gaTrackEvent('GoalFacebookSignup');
  } else if (eventName == 'Membership Upgrade') {
    gaTrackEvent('GoalMembershipUpgrade');
  } else if (eventName == 'Contest Reposted') {
    _ttref.push(['_setEntrypoint', 'Contest_RepostSuccessContest']);
    gaTrackEvent('GoalContestCreated');
  } else if (eventName == 'Contest Created') {
    gaTrackEvent(['_trackEvent', 'Goal', 'Contest Created']);
  } else if (eventName === 'Contest Posted') {
    gaTrackEvent('GoalContestPaid');
  } else if (eventName == 'Entries Submitted') {
    // track the submitted entries from dropdown notification
    if (event.xp_contest) {
      _ttref.push(['_trackEvent', 'Contest', 'SubmitEntry', 'XP Contest']);
      _ttref.push(['_clearEntrypoint', 'Contest']);
    }
    if (event.realtime_contest) {
      _ttref.push([
        '_trackEvent',
        'Contest',
        'SubmitEntry',
        'Realtime Notification Contest',
      ]);
      _ttref.push(['_clearEntrypoint', 'Contest']);
    }
    gaTrackEvent('GoalEntriesSubmitted');
  } else if (eventName == 'Services Bought') {
    gaTrackEvent('GoalServicesBought');
  } else if (eventName == 'Services Posted') {
    gaTrackEvent('GoalServicesPosted');
  } else if (eventName == 'Deposit Money') {
    gaTrackEvent('GoalDepositMoney');
  } else if (eventName == 'Suggestion Click') {
    _t.push([
      'project_suggestion_redirect',
      {
        bidder_id: event.bidder_id,
        src_project_id: event.src_project_id,
        dst_project_id: event.dst_project_id,
        time: new Date(),
      },
    ]);
    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_Suggestion']);
    _ttref.push([
      '_trackEvent',
      'Project',
      'Suggestion',
      'clicked',
      0,
      false,
      true,
    ]);
  } else if (eventName == 'Service View') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        label: 'ViewPage',
        action: 'view',
      },
    ]);
  } else if (eventName == 'Service Order Modal Cancel') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        subsection: 'OrderModal',
        label: 'OrderModalCancel',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Button Click') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        label: 'OrderButton',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Confirm Modal') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        subsection: 'OrderModal',
        label: 'OrderModal',
        action: 'view',
      },
    ]);
  } else if (eventName == 'Service Order Button Click Logged Out') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        label: 'OrderButtonLoggedOut',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Payment Verified') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        label: 'OrderModalOkPaymentVerified',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Modal Purchase') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        label: 'OrderModalOkPurchase',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Modal Ok') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        subsection: 'OrderModal',
        label: 'OrderModalOk',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Login Modal Login') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        subsection: 'OrderLoginModal',
        label: 'Login',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Login Modal FB Login') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        subsection: 'OrderLoginModal',
        label: 'FBLogin',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Login Modal Sign Up') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        subsection: 'OrderLoginModal',
        label: 'SignUp',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Service Order Deposit') {
    _t.push([
      'user_action',
      {
        section: 'ServiceDepositPage',
        label: 'OrderDepositPage',
        action: 'view',
      },
    ]);
  } else if (eventName == 'Service Order Deposit Success') {
    _t.push([
      'user_action',
      {
        section: 'ServiceProjectPage',
        label: 'ServicePurchasedFromDeposit',
        action: 'view',
      },
    ]);
  } else if (eventName == 'Dashboard MyProjects') {
    _t.push([
      'user_action',
      {
        section: 'Dashboard',
        subsection: 'Topnav',
        label: 'MyProjects',
      },
    ]);
  } else if (eventName == 'Service Order Deposit Other Methods') {
    _t.push([
      'user_action',
      {
        section: 'ServiceViewPage',
        subsection: 'OrderDepositModal',
        label: 'OrderDepositOtherMethods',
        action: 'view',
      },
    ]);
  } else if (eventName == 'Showcase Upsell PVP') {
    gaTrackEvent('GoalProjectShowcaseReposted');

    _ttref.push(['_clearEntrypoint', 'Project']);
    _ttref.push(['_setEntrypoint', 'Project_ShowcaseUpsell']);

    _t.push([
      'user_action',
      {
        section: 'ProjectShowcaseUpsell',
        subsection: 'RepostButton',
        label: event.source,
        action: 'click',
      },
    ]);
  } else if (eventName == 'Front Page Log In') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'FrontPageUpperRight',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Post Project Log In') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'PostProjectPage',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Post Contest Log In') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'PostContestPage',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Top Right Corner') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'TopRightCorner',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Hire Me Page') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'HireMePage',
        action: 'click',
      },
    ]);
  } else if (eventName == 'User Login Page') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'UserLogInPage',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Repost Page') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'RepostPage',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Sign Up Modal') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'SignUpModal',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Find Freelancers Page') {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'LoginAttempt',
        label: 'FindFreelancersPage',
        action: 'click',
      },
    ]);
  } else if (eventName == 'Directory Page Search') {
    _t.push([
      'search',
      {
        section: 'Directory',
        source: event.source,
        keyword: event.keyword,
        filters: event.filters,
        items_displayed: event.items_displayed,
        items_count: event.items_count,
        items_page: event.items_page,
      },
    ]);
  } else if (eventName == 'Navigation Bar Search') {
    _t.push([
      'search',
      {
        section: 'MainNav',
        keyword: event.keyword,
      },
    ]);
  } else if (eventName == 'Jobs Page Search') {
    _t.push([
      'search',
      {
        section: 'JobTable',
        source: event.source,
        keyword: event.keyword,
        filters: event.filters,
        items_displayed: event.items_displayed,
        items_count: event.items_count,
        items_page: event.items_page,
        sort: event.sort,
      },
    ]);
  } else if (eventName == 'Work Search') {
    _t.push([
      'search',
      {
        section: 'WorkTable',
        source: event.source,
        keyword: event.keyword,
        filters: event.filters,
        items_displayed: event.items_displayed,
        items_count: event.items_count,
        items_page: event.items_page,
        sort: event.sort,
      },
    ]);
  } else if (eventName == 'Project View Page - Upsell Banner') {
    _t.push([
      'user_action',
      {
        section: 'ProjectViewPage',
        subsection: event.eventOption.subsection,
        label: event.eventOption.label,
        action: event.eventOption.action,
      },
    ]);
  } else if (eventName === 'Project View Page - Bid on this project') {
    _t.push([
      'user_action',
      {
        section: 'Project',
        sub_section: 'BidTheProject',
        label: event.label,
      },
    ]);
  } else {
    _t.push(event);
  }
}

function LocalTracking() {
  this._events = [];
}

LocalTracking.prototype._save = function() {
  try {
    localStorage.setItem('LocalTracking', JSON.stringify(this._events));
  } catch (e) {
    return false;
  }
};

LocalTracking.prototype._restore = function() {
  try {
    const events = JSON.parse(localStorage.getItem('LocalTracking'));
    for (let _i = 0, _len = events.length; _i < _len; _i++) {
      this.push(events[_i]);
    }
  } catch (e) {
    return false;
  }
};

LocalTracking.prototype._process = function() {
  const events = this._events;
  this._events = [];
  for (let _i = 0, _len = events.length; _i < _len; _i++) {
    processEvent(events[_i]);
  }
  try {
    localStorage.removeItem('LocalTracking');
  } catch (e) {
    return false;
  }
  return true;
};

LocalTracking.prototype.push = function(event, options) {
  let delay = 5000;

  if (typeof options === 'object') {
    delay = options.delay ? options.delay : delay;
  }

  this._events.push(event);
  this._save();
  const self = this;
  setTimeout(() => {
    self._process();
  }, delay);
  return 1;
};

LocalTracking.prototype.init = function(_t) {
  let event;
  let _i;
  let _len;
  this._restore();
  if (_t == null) {
    _t = [];
  }
  for (_i = 0, _len = _t.length; _i < _len; _i++) {
    event = _t[_i];
    this.push(event);
  }
  return this;
};

export { gaTrackEvent } from './all-ga-events';

export default LocalTracking;
